'use strict';

function onViewLabelsForLanguageFactory() {
  const languageLabels = {
    'ptBr': {
      'ABOUT':                         'Sobre o ObrasGov Mapa',
      'AGREED':                        'Contratado',
      'APPLY':                         'Aplicar',
      'AREA':                          'Área',
      'ATTACHED_FILE':                 'Arquivo anexado',
      'BORDERS':                       'Fronteiras',
      'CANCEL':                        'Cancelar',
      'CENTER_ON_ME':                  'Centralizar mapa na minha localização',
      'CLEAN_ADDRESS':                 'Limpar o endereço da busca',
      'CLEAR':                         'Limpar',
      'CLOSE':                         'Fechar',
      'CLOSE_HEAT_MAP':                'Fechar mapa de calor',
      'COMPANIES':                     'Empresas',
      'CONFIG_HEAT_MAP_BY':            'Configurar mapa de calor por',
      'CONSTRUCTION_SITES':            'Obras',
      'CONSTRUCTION_SITES_FILTER':     'Filtro de obras',
      'CONTRACTS':                     'Contratos',
      'CONTRACTS_NUMBER':              'Número de contratos',
      'DATE_FORMAT':                   'Formato dia/mês/ano',
      'DETAILS':                       'Detalhes',
      'DETALHADO':                     'Detalhado',
      'DOCUMENTS':                     'Contratos/Convênios',
      'DOCUMENTS_PORTAL':              'Portal de documentos',
      'DURATION':                      'Duração',
      'EMAIL':                         'E-mail',
      'EXECUTED':                      'Executado',
      'EXPANDED':                      'Expandido',
      'EXPORT_AS_PDF':                 'Exportar como PDF',
      'EXPORT_AS_ODT':                 'Exportar como ODT',
      'FAVORITE_FILTERS':              'Consultas predefinidas',
      'FILTERS':                       'Filtros',
      'FINANCIAL_INFORMATION':         'Informações financeiras',
      'FINAL_DATE':                    'Data final',
      'FINALIZED':                     'Concluído',
      'FOUND_CONTRACT':                'contrato encontrado.',
      'FOUND_CONTRACTS':               'contratos encontrados.',
      'FOUND_COVENANT':                'convênio encontrado.',
      'FOUND_COVENANTS':               'convênios encontrados.',
      'FROM':                          'Nome',
      'GENERAL_INFORMATION':           'Informações gerais',
      'HEAT_MAP':                      'Mapa de calor',
      'HOME':                          'Inicio',
      'INFORMATION':                   'Informações',
      'INITIAL_DATE':                  'Data inicial',
      'LAYERS':                        'Camadas',
      'LOCAL':                         'Local',
      'LEGEND':                        'Legenda',
      'PAID':                          'Pago',
      'PAID_AST':                      'Pago *',
      'PAID_DESC':                     '* Valor Pago = Preços iniciais + Reajustes e correções monetárias',
      'MAP':                           'Mapa',
      'MESSAGE':                       'Messagem',
      'NAME':                          'Nome',
      'NO_REPORTS':                    'Sem contratos para exibir',
      'NOT_EXPANDED':                  'Não expandido',
      'NOT_SELECTED':                  'Não selecionado',
      'OPEN':                          'Abrir',
      'ORDER_BY':                      'Ordenar por',
      'OTHERS_ADDRESS':                'OUTRAS OBRAS NOS SEGUINTES ENDEREÇOS',
      'PHOTOS':                        'Fotos',
      'REPORTS':                       'Relatórios',
      'PERIOD':                        'Período',
      'PRINT':                         'Imprimir',
      'QUANTITY':                      'Quantidade',
      'REQUIRED':                      'Campo obrigatório',
      'RESTORE':                       'Restaurar',
      'SATELLITE':                     'Satélite',
      'SEARCH':                        'Buscar',
      'SEEK_FOR_ADDRESS':              'Buscar endereço',
      'SELECT':                        'Selecionar',
      'SELECTED':                      'Selecionado',
      'SEND':                          'Enviar',
      'SEND_EMAIL':                    'Enviar e-mail',
      'SHOW_ON_MAP':                   'Mostrar no mapa',
      'SIMPLIFICADO':                  'Simplificado',
      'SITUATION_STATUS':              'Situação',
      'SUBJECT':                       'Assunto',
      'SUPERVISORS':                   'Fiscais da Obra',
      'SUPERVISORS_DOC':               'Conselho',
      'SUPERVISORS_JOB':               'Cargo',
      'SUPERVISORS_NAME':              'Nome',
      'SUPERVISORS_PORT':              'Portaria',
      'TERM_CONTRACT':                 'Prazos de Execução',
      'TOTAL':                         'Totais',
      'TOTAL_VALUE':                   'Valor total de ',
      'VALUE':                         'Valor',
      'VIDEO':                         'Acesse aqui o vídeo explicativo sobre o Mapa de Obras',
      'VIDEO_TITLE':                   'Vídeo explicativo sobre o Mapa de Obras',
      'MOREPICTURES':                  '+Fotos',
      'ALBUMPHOTOS':                   'Álbum de Fotos',
      'EDITAL':                        'Edital',
      'EDITAL_DATA_PROCESSO':          'Data do Processo',
      'EDITAL_NUM_PROCESSO':           'Nº do Processo',
      'EDITAL_ANO_DOE':                'Ano do Edital (DOE)',
      'EDITAL_NUM_DOE':                'Nº do Edital (DOE)',
      'EDITAL_DATA_PUBLICACAO':        'Data de Publicação',
      'EDITAL_DATA_DOE':               'Data do Edital (DOE)',
      'EDITAL_DATA_HOMOLOGACAO':       'Data de Homologação',
      'EDITAL_MODALIDADE':             'Modalidade',
      'LICENCAAMBIENTAL':              'Licenças Ambientais',
      'LICENCA_AMBIENTAL_ORGAO':       'Orgão Licenciador',
      'LICENCA_AMBIENTAL_NUM_LICEN':   'Nº da Licença',
      'LICENCA_AMBIENTAL_REFERENCIA':  'Nº de Referência',
      'LICENCA_AMBIENTAL_ATIVIDADE':   'Atividade',
      'LICENCA_AMBIENTAL_TP_LICEN':    'Tipo de Licença',
      'LICENCA_AMBIENTAL_DT_EMISSAO':  'Emissão',
      'LICENCA_AMBIENTAL_DT_VALIDADE': 'Validade',
      'MENSAGEM_NADA_ENCONTRADO':      'Nenhuma informação encontrada para esse contrato!',
      'TITLE_IMAGE_POSITIVE':          '* Fotos da obra',
      'TITLE_IMAGE_NEGATIVE':          '* Esta obra não possui fotos até o momento',
      'TITLE_COORDINATES_POSITIVE':    '* Localização da obra',
      'TITLE_COORDINATES_NEGATIVE':    '* Esta obra não possui coordenadas até o momento',
      'TITLE_DOCUMENT_POSITIVE':       '* Documentos do contrato',
      'TITLE_DOCUMENT_NEGATIVE':       '* Este contrato não possui documentos até o momento',
      'DETALHE':                       'DETALHE',
      'DETALHES':                      'Detalhes',
      'TÍTULO':                        'TÍTULO',
      'DOCUMENTOS':                    'DOCUMENTOS',
      'TOOLTIP_HOME':                  'Exibe a tela com o mapa na visão inicial',
      'TOOLTIP_FILTERS':               'Possibilita filtrar os contratos por período, situação, tipo de obra, entre outros',
      'TOOLTIP_CONTRACTS':             'Exibe a lista de contratos, juntamente com a sua localização e imagens',
      'DOCUMENTS_PORTAL_DETAILS':      'Acesse aqui a documentação disponível do contrato',
      'TOOLTIP_REPORT_EDITABLE':       'Relatório detalhado editável',
      'ULTIMA_ATUALIZACAO':            'Última Atualização:'
    }
  };
  return {
		getLabels: function(language) {
			return languageLabels[language];
		}
	};
}
export default onViewLabelsForLanguageFactory



// WEBPACK FOOTER //
// ./src/app/scripts/factories/onViewLabelsForLanguageFactory.js